import { SessionStore } from '~/stores/session'
import type { PushToSaveScenarios } from '~/composables/PushToSave'

export default class SaveProgressAutoPop {
  static use() {
    const { route } = AppRoute.use()
    const session = SessionStore.use()

    const maybeAutoPop = (scenario: PushToSaveScenarios, dialogId: string) => {
      if (session.autoPopSaveProgressShown) return

      const shown = PushToSave.use(scenario, dialogId).maybePushToSave()
      if (shown) session.autoPopSaveProgressShown = true
    }

    watch(
      () => route.fullPath,
      (to, from) => {
        const startedApp = from === '/apply' || from.startsWith('/apply/')
        const backToQuoteResults =
          to === '/quotes' || to === '/compare' || to.startsWith('/details')

        if (startedApp && backToQuoteResults) {
          maybeAutoPop('back-from-started-app', 'push-to-save-back-from-started-app')
          return
        }

        const backFromQuotesToNeedsAssessment =
          from === '/quotes' &&
          !['/quotes', '/compare'].includes(to) &&
          !to.startsWith('/details') &&
          !to.startsWith('/apply')

        if (backFromQuotesToNeedsAssessment) {
          maybeAutoPop('back-from-quotes', 'push-to-save-back-from-quotes')
        }
      }
    )
  }
}
